import styled from 'styled-components/macro';

export const StyledApplicationListContainer = styled.div`
  margin-top: 0;
  min-height: 300px;
  height: 100%;
  position: relative;
  margin-top: -14px;
  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    ${(props) => props.hideCardsOnMobile && 'display:none;'};
  }
  & > div:first-child {
    margin-top: 0;
  }
  ${(props) =>
    props.scrollList
      ? `
        overflow-x: hidden;
        overflow-y: auto;
        max-height: 600px;
    `
      : ``}

  ${(props) =>
    props.isOver &&
    `
        & > .application-card {
            pointer-events:none;
        }
    `}
`;

export const StyledNoneApplications = styled.div`
  width: 100%;
  background-color: ${(props) => props.theme.colors.almostWhite};
  border: 1px solid ${(props) => props.theme.colors.mgrey};
  box-shadow: 0 0 8px rgba(24, 31, 56, 0.06);
  border-radius: 5px;
  margin-bottom: 20px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  position: relative;
  justify-content: space-between;
  transition: 0.2s ease;

  @media (max-width: 992px) {
    height: 80px;
    margin-bottom: 8px;
  }

  h3 {
    font-size: 18px;
  }
`;